"use client";

import Link from "next/link";
import "./globals.css";

interface GlobalErrorProps {
  error: Error & { digest?: string };
  reset: () => void;
}

export default function GlobalError({ reset }: GlobalErrorProps) {
  return (
    <html lang="en">
      <body style={{ margin: 0, backgroundColor: "#f5f0e8", fontFamily: "sans-serif" }}>
        <main
          style={{
            minHeight: "100vh",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            padding: "1rem",
          }}
        >
          <div style={{ textAlign: "center", maxWidth: "28rem" }}>
            <p
              aria-hidden="true"
              style={{ fontSize: "6rem", fontWeight: 700, color: "#e5d9c8", margin: "0 0 1.5rem" }}
            >
              500
            </p>
            <h1 style={{ fontSize: "1.5rem", fontWeight: 700, color: "#1b3a2d", margin: "0 0 0.75rem" }}>
              We&rsquo;ve spilled the pint
            </h1>
            <p style={{ color: "#6b7a6b", margin: "0 0 2rem" }}>
              Something went wrong behind the bar. Give us a moment to mop up.
            </p>
            <div style={{ display: "flex", flexDirection: "column", gap: "0.75rem", alignItems: "center" }}>
              <button
                onClick={reset}
                style={{
                  padding: "0.75rem 1.5rem",
                  borderRadius: "9999px",
                  fontSize: "0.875rem",
                  fontWeight: 600,
                  backgroundColor: "#c06428",
                  color: "#ffffff",
                  border: "none",
                  cursor: "pointer",
                }}
              >
                Try again
              </button>
              <Link
                href="/"
                style={{
                  padding: "0.75rem 1.5rem",
                  borderRadius: "9999px",
                  fontSize: "0.875rem",
                  fontWeight: 600,
                  border: "1px solid #e5d9c8",
                  color: "#1b3a2d",
                  textDecoration: "none",
                }}
              >
                Back to home
              </Link>
            </div>
          </div>
        </main>
      </body>
    </html>
  );
}
